import { forwardRef } from 'react'

import { Link } from 'react-router-dom'
import type { LinkProps } from 'react-router-dom'

import type { ChildrenType } from '../types'

type RouterLinkProps = Omit<LinkProps, 'to'> & {
  href: string
  className?: string
} & Partial<ChildrenType>

export const RouterLink = forwardRef((props: RouterLinkProps, ref: any) => {
  const { href, className, ...other } = props

  return (
    <Link ref={ref} to={href} className={className} {...other}>
      {props.children}
    </Link>
  )
})
